"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gs_1 = require("@ivanlog/gs");
const AppVX_1 = require("./classes/AppVX");
const tmplsInj_1 = require("./classes/com/tmplsInj");
gs_1.FormGS.TagClassName = 'px-form';
gs_1.WrapperGS.ExtendComponentsByTagClass(gs_1.FormGS);
(0, tmplsInj_1.InjectComponents)();
//gs.StateGS.Initialize(true); 
globalThis.app = new AppVX_1.AppVX();
//# sourceMappingURL=index.js.map